import { createContext } from "react"

const dataContext = createContext(null);

export default dataContext;